import Information from '@/modules/attendance/components/information/information';
import InformationAttachments from '@/modules/attendance/components/informationAttachments/informationAttachments';
import InformationContracts from '@/modules/attendance/components/informationContracts/informationContracts';
import { useAttendance } from '@/modules/attendance/hooks';
import { useHistoryParams } from '@/navigation';
import React from 'react';

const Detail: React.FC = () => {
  const { attendanceId } = useHistoryParams();
  const { isLoading, attendance } = useAttendance({ attendanceId });

  return (
    <>
      <Information attendance={attendance} />

      <InformationContracts isLoading={isLoading} contracts={attendance.contracts} />

      <InformationAttachments isLoading={isLoading} attachments={attendance.attachments} />
    </>
  );
};

export default Detail;
